import actionBarComponent from "@/components/child/actionBar/actionBar.vue";
import buttonIncluirComponent from "@/components/child/form/button/buttonIncluir.vue";
import cepFieldComponent from "@/components/child/form/cepfield.vue";
import checkboxComponent from "@/components/child/form/checkbox.vue";
import comboComponent from "@/components/child/form/combo.vue";
import dataTooltipComponent from "@/components/child/form/datatooltip.vue";
import dateTimePickerComponent from "@/components/child/form/datetimepicker.vue";
import decimalComponent from "@/components/child/form/decimal.vue";
import decimalComSinalCustomComponent from "@/components/child/form/decimalComSinalCustom.vue";
import fieldsetComponent from "@/components/child/form/fieldset.vue";
import moedaComponent from "@/components/child/form/moeda.vue";
import textareaComponent from "@/components/child/form/textarea.vue";
import gridComponent from "@/components/child/grid/grid.vue";
import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import infoBagdeComponent from "@/components/child/infoBagde/infoBagde.vue";
import logEntidadeComponent from "@/components/child/logEntidade/logEntidade.vue";
import InformacoesAdicionaisRepresentanteListComponent from "@/components/parent/informacoesAdicionaisRepresentante/list";
import informacoesAdicionaisRepresentanteListComponent from "@/components/parent/informacoesAdicionaisRepresentante/list.vue";
import { Component, Prop } from "@/decorators";
import CepModel from "@/models/cepModel";
import ClienteModel from "@/models/clienteModel";
import ComissaoPrescritorFaixaModel from "@/models/comissaoPrescritorFaixaModel";
import AreaAtuacao from "@/models/enum/areaAtuacao";
import EnumExtensions from "@/models/enum/extensions/enumExtensions";
import CurvaABC from "@/models/enum/produto/curvaABC";
import TipoConselhoRegional from "@/models/enum/tipoConselhoRegional";
import Ufs from "@/models/enum/ufs";
import EspecialidadeModel from "@/models/especialidadeModel";
import PaginationModel from "@/models/paginationModel";
import PrescritorEspecialidadeModel from "@/models/prescritorEspecialidadeModel";
import PrescritorModel from "@/models/prescritorModel";
import beneficioService from "@/services/beneficioService";
import ClienteService from "@/services/clienteService";
import EspecialidadeService from "@/services/especialidadeService";
import CidadeService from "@/services/external/cidadeService";
import PrescritorService from "@/services/prescritorService";
import { Getters } from "@/store/store";
import { editDateWithTime } from "@/utils/common/date";
import Delay from "@/utils/common/delay";
import { mapGetters } from "vuex";
import EditComponentBase from "../editComponentBase";
import ReplicarSelecaoFranquiaFiliaisComponent from "../replicarSelecaoFranquiaFiliais/edit";
import replicarSelecaoFranquiaFiliaisComponent from "../replicarSelecaoFranquiaFiliais/edit.vue";

import GenerosPessoa from "@/models/enum/generosPessoa";
import { BaseOption, FranquiaOption } from "@/types/options";
import { AcaoController, DescricaoTela } from "@/utils/common/permissionConstants";
import "../crud.scss";
import "./edit.scss";

interface ConsultaCRMResponseDto {
    sucesso: boolean;
    codigo?: number;
    mensagem?: string;
    nome?: string;
    situacao?: string;
    especialidades?: string[];
}

@Component({
    components: {
        textareaComponent,
        checkboxComponent,
        comboComponent,
        dataTooltipComponent,
        fieldsetComponent,
        decimalComponent,
        cepFieldComponent,
        dateTimePickerComponent,
        gridComponent,
        replicarSelecaoFranquiaFiliaisComponent,
        decimalComSinalCustomComponent,
        moedaComponent,
        buttonIncluirComponent,
        logEntidadeComponent,
        actionBarComponent,
        infoBagdeComponent,
        informacoesAdicionaisRepresentanteListComponent,
    },
    computed: {
        infoBagdeText() {
            return "Data criação: " + editDateWithTime(this.model.dataCriacao);
        },
        infoBagdeTextUsuario() {
            return this.model.usuarioCriacaoNome ? "Usuário criação: " + this.model.usuarioCriacaoNome : "";
        },
        isFranquiaHumana(): boolean {
            return this.usuarioLogado?.franquia?.areaAtuacao === AreaAtuacao.Humana;
        },
        isCRM(): boolean {
            return this.model.tipoConselhoRegional === TipoConselhoRegional.CRM;
        },
        shouldShowAlteredOrder(): boolean {
            return this.isFranquiaHumana && this.isCRM;
        },
        ...mapGetters(["VALIDAR_PERMISSAO_USUARIO"] as Getters),
    },
})
export default class PrescritorEditComponent extends EditComponentBase<PrescritorModel> {
    // State computed props
    VALIDAR_PERMISSAO_USUARIO: (telaDescricao: string, acaoController: string) => boolean;
    private bloquearFlagAtivacao = false;

    infoBagdeText?: string;
    private isFranquiaHumana: boolean;
    private isCRM: boolean;
    private shouldShowAlteredOrder: boolean;

    private cidadeService = new CidadeService();
    private prescritorService = new PrescritorService();
    private clienteService = new ClienteService();
    private replicarSelecaoFranquiaFiliaisComponent: ReplicarSelecaoFranquiaFiliaisComponent = null;
    private informacoesAdicionaisRepresentanteListComponent: InformacoesAdicionaisRepresentanteListComponent = null;

    private generosPessoaOptions: Array<BaseOption> = [
        { text: this.$t("__.ts.masculino") as string, value: GenerosPessoa.Masculino },
        { text: this.$t("__.ts.feminino") as string, value: GenerosPessoa.Feminino },
    ];
    private curvaABCOptions: Array<BaseOption> = [
        { text: "A", value: CurvaABC.A },
        { text: "B", value: CurvaABC.B },
        { text: "C", value: CurvaABC.C },
    ];
    private ufOptions: Array<BaseOption> = EnumExtensions.getNamesAndValuesOrderedByNames(Ufs);
    private cidadesOptions: Array<Object> = [];
    private conselhosRegionaisOptions: Array<Object> =
        EnumExtensions.getNamesAndValuesOrderedByNames(TipoConselhoRegional);
    private especialidadesOptions: Array<BaseOption> = [];
    private beneficiosOptions: Array<FranquiaOption> = [];

    visitadoresNomes: string | null = null;

    @Prop({ type: Boolean, default: false }) CalledByShortCut: boolean;

    get gridColumns(): Array<GridColumn> {
        return [new GridColumn("especialidadeDescricao", "Descri\u00e7\u00e3o", GridColumnType.String)];
    }

    gridFaixaColums: Array<GridColumn> = [
        new GridColumn("inicioFaixa", "Faixa Inicio", GridColumnType.Money),
        new GridColumn("fimFaixa", "Faixa Fim", GridColumnType.Money),
        new GridColumn("porcentagemComissao", "Porcentagem Comissão", GridColumnType.Percent),
    ];

    faixaComissao = new ComissaoPrescritorFaixaModel();
    dadosCep: CepModel = new CepModel();

    private async beforeMount() {
        await this.setProps(new PrescritorService(), "prescritores", new PrescritorModel(), this.CalledByShortCut);

        await this.loadEspecialidades().withLoading();
        await this.loadBeneficios().withLoading();

        if (this.CalledByShortCut) {
            this.model = new PrescritorModel();
        }

        if (!this.model.id && this.isFranquiaHumana) {
            this.model.tipoConselhoRegional = TipoConselhoRegional.CRM;
        }
    }

    public async onPreLoadModel() {
        this.visitadoresNomes = null;
        const isAdmin = await this.HAS_PERMISSAO_PERFIL(false, false, false);
        const temPermissao = this.VALIDAR_PERMISSAO_USUARIO(DescricaoTela.prescritores, AcaoController.activation);
        this.bloquearFlagAtivacao = !isAdmin && !temPermissao;
        return true;
    }

    public async onLoadModel(model: PrescritorModel) {
        await this.onLoadCidades(model.estadoId);

        if (this.model.visitadores.length > 0) {
            this.visitadoresNomes = this.model.visitadores.map(p => p.visitador.nome).join(", ");
        }
    }

    private async loadEspecialidades() {
        try {
            const data = await new EspecialidadeService()
                .combo()
                .resolveWithJSON<PaginationModel<EspecialidadeModel>>();
            this.especialidadesOptions = data.list.map(item => ({ value: item.id!, text: item.descricao }));
        } catch {}
    }

    private stripCfmEspecialidadeRqeSuffix(nome: string): string {
        return nome.replace(/\s*-\s*RQE.*$/, "").trim();
    }

    private normalizeEspecialidadeMatchKey(text: string | null | undefined): string {
        if (!text) {
            return "";
        }
        return text
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .trim()
            .toLowerCase();
    }

    private mergeEspecialidadesFromConsultaCfm(nomes: string[]): void {
        for (const nomeCfm of nomes) {
            const matchKey = this.normalizeEspecialidadeMatchKey(this.stripCfmEspecialidadeRqeSuffix(nomeCfm));

            const jaExiste = this.model.especialidades.some(
                e => this.normalizeEspecialidadeMatchKey(e.especialidadeDescricao) === matchKey,
            );

            if (jaExiste) {
                continue;
            }

            const especialidade = this.especialidadesOptions.find(
                option => this.normalizeEspecialidadeMatchKey(option.text) === matchKey,
            );

            const item = new PrescritorEspecialidadeModel();
            if (especialidade) {
                item.especialidadeId = especialidade.value;
                item.especialidadeDescricao = especialidade.text;
                this.model.especialidades.push(item);
            }
        }
    }

    private onInclusaoEspecialidade() {
        const especialidadeComponent = this.$el.querySelector("#especialidadeId") as HTMLSelectElement;

        if (this.model.especialidadeId > 0) {
            const alreadyExists = this.model.especialidades.filter(p => p.id == this.model.especialidadeId).length > 0;

            if (!alreadyExists) {
                const prescritorEspecialidadeModel = new PrescritorEspecialidadeModel();
                prescritorEspecialidadeModel.especialidadeId = this.model.especialidadeId;
                prescritorEspecialidadeModel.especialidadeDescricao = especialidadeComponent.innerText;

                this.model.especialidades.push(prescritorEspecialidadeModel);

                this.model.especialidadeId = -1;
            }
        }
    }

    private validarVisibilidadeBotoes(botao: string): boolean {
        if (botao == "replicar-filiais") {
            return (
                this.model.id > 0 &&
                this.usuarioLogado.franquia.isFranquiaMatrizOrFilial &&
                this.VALIDAR_PERMISSAO_USUARIO("franquias", "ReplicarItensFiliais")
            );
        }

        return true;
    }

    private onReplicarFiliais() {
        this.replicarSelecaoFranquiaFiliaisComponent = this.$refs
            .replicarSelecaoFranquiaFiliaisComponent as ReplicarSelecaoFranquiaFiliaisComponent;
        this.replicarSelecaoFranquiaFiliaisComponent.openFranquias();
    }

    private async onConfirmReplicar(franquiasIds: Array<number>) {
        try {
            const sucesso = await this.prescritorService
                .replicarPrescritor(this.model.id, franquiasIds)
                .withLoading()
                .resolveWithoutJSON();
            if (sucesso) {
                this.$showSuccess("Replicou", this.$t("__.ts.regisSalvosSucess"));
            }
        } catch {}
    }

    private onRemoveItem(model: PrescritorEspecialidadeModel) {
        this.model.especialidades = this.model.especialidades.filter(p => p != model);
    }

    private async onCepChanged(data: CepModel) {
        this.dadosCep = data;
        this.model.bairro = data.bairro;
        this.model.complemento = data.complemento;
        this.model.endereco = data.endereco;
        this.model.estadoId = data.uf;
        await this.onLoadCidades(this.model.estadoId);
        this.model.cidadeId = data.cidadeId;
    }

    private onRemoveFaixa(item) {
        const index = this.model.comissoesFaixa.indexOf(item);
        this.model.comissoesFaixa.splice(index, 1);
    }

    private async loadBeneficios() {
        try {
            this.beneficiosOptions = await beneficioService.comboCached(this.usuarioLogado.franquiaId!);
        } catch {}
    }

    public atualizarBeneficios() {
        this.loadBeneficios();
    }

    private async onAddFaixa() {
        if (this.faixaComissao.inicioFaixa < this.faixaComissao.fimFaixa) {
            const model = new ComissaoPrescritorFaixaModel();
            model.updateFrom(this.faixaComissao);
            this.faixaComissao = new ComissaoPrescritorFaixaModel();
            this.model.comissoesFaixa.push(model);
        } else {
            this.$showWarning(this.$t("__.ts.atencao"), this.$t("__.ts.faixaFinalMaior"));
        }
    }

    private onCepInvalid() {
        this.$showInfo(this.$t("__.ts.pesqCEP"), this.$t("__.ts.pesqNaoEncResul"));
    }

    private async onLoadCidades(estadoId: number) {
        try {
            this.cidadesOptions = [];
            if (estadoId) {
                this.cidadesOptions = await this.cidadeService.get(estadoId).withLoading();
            }
        } catch {}
    }

    private async onShowInformacoesAdicionaisRepresentante() {
        while (!this.$refs.informacoesAdicionaisRepresentanteListComponent) await Delay(100);
        this.informacoesAdicionaisRepresentanteListComponent = this.$refs
            .informacoesAdicionaisRepresentanteListComponent as InformacoesAdicionaisRepresentanteListComponent;
        this.informacoesAdicionaisRepresentanteListComponent.show(this.model.id, 2);
    }

    private async onBlurCpf() {
        if (this.model.id || this.somenteConsulta) {
            return;
        }
        const cpfLimpo = this.model.cpf ? this.model.cpf.replace(/[^0-9]/g, "") : "";

        if (!cpfLimpo || cpfLimpo.length !== 11) {
            return;
        }

        try {
            const response = await this.clienteService.getByCPF(cpfLimpo).withLoading().resolveWithJSON<ClienteModel>();

            if (response) {
                const confirmar = await this.$showQuestion(
                    this.$t("__.ts.atencao"),
                    this.$t("__.Crud.prescritor.edit_vue_html.clienteEncontradoConfirmacao"),
                );

                if (confirmar) {
                    if (response.nome && !this.model.nome) {
                        this.model.nome = response.nome;
                    }
                    if (response.rg && !this.model.rg) {
                        this.model.rg = response.rg;
                    }
                    if (response.dataNascimento && !this.model.dataNascimento) {
                        this.model.dataNascimento = response.dataNascimento;
                    }
                    if (response.genero && !this.model.genero) {
                        this.model.genero = response.genero;
                    }
                    if (response.cep && !this.model.cep) {
                        this.model.cep = response.cep;
                    }
                    if (response.estadoId && !this.model.estadoId) {
                        this.model.estadoId = response.estadoId;
                        await this.onLoadCidades(this.model.estadoId);
                    }
                    if (response.cidadeId && !this.model.cidadeId) {
                        this.model.cidadeId = response.cidadeId;
                    }
                    if (response.endereco && !this.model.endereco) {
                        this.model.endereco = response.endereco;
                    }
                    if (response.bairro && !this.model.bairro) {
                        this.model.bairro = response.bairro;
                    }
                    if (response.numero && !this.model.numero) {
                        this.model.numero = response.numero;
                    }
                    if (response.complemento && !this.model.complemento) {
                        this.model.complemento = response.complemento;
                    }
                    if (response.email && !this.model.email) {
                        this.model.email = response.email;
                    }
                    if (response.observacao && !this.model.observacao) {
                        this.model.observacao = response.observacao;
                    }

                    if (response.telefonePadrao && response.telefonePadrao != "") {
                        this.model.telefone = response.telefonePadrao;
                    }
                }
            }
        } catch {}
    }

    private async verificarEBuscarDadosCFM() {
        if (
            this.shouldShowAlteredOrder &&
            this.model.ufConselhoRegional &&
            this.model.numeroRegistro &&
            this.model.numeroRegistro.toString().trim() !== ""
        ) {
            if (!this.model.id && !this.somenteConsulta) {
                await this.buscarDadosMedicoCFM();
            }
        }
    }

    private limparDadosPreenchidosPeloCFM() {
        this.model.nome = null;
        this.model.especialidades = [];
    }

    private async buscarDadosMedicoCFM() {
        if (!this.shouldShowAlteredOrder) {
            return;
        }

        try {
            const ufSigla = Ufs[this.model.ufConselhoRegional as number];
            const response = await this.prescritorService
                .consultarCRM(ufSigla, this.model.numeroRegistro.toString())
                .withLoading()
                .resolveWithJSON<ConsultaCRMResponseDto>(false);

            if (response && response.sucesso) {
                this.limparDadosPreenchidosPeloCFM();

                if (response.nome) {
                    this.model.nome = response.nome;
                }

                if (response.especialidades?.length) {
                    this.mergeEspecialidadesFromConsultaCfm(response.especialidades);
                }

                if (response.situacao === "A") {
                    this.$notifySuccess("Dados do médico encontrados e preenchidos automaticamente");
                } else {
                    this.$showWarning(
                        "Médico encontrado, mas em situação irregular",
                        `Situação: ${this.getDescricaoSituacao(response.situacao)}`,
                    );
                }
            } else if (response && response.codigo === 8101) {
                this.limparDadosPreenchidosPeloCFM();
                this.$notifyWarn("Médico não encontrado no CFM");
            } else if (response && !response.sucesso && response.mensagem) {
                this.limparDadosPreenchidosPeloCFM();
                this.$notifyError(response.mensagem);
            }
        } catch {
            return;
        }
    }

    private getDescricaoSituacao(situacao: string): string {
        const situacoes: { [key: string]: string } = {
            A: "Regular",
            B: "Suspensão parcial permanente",
            C: "Cassado",
            E: "Inoperante",
            F: "Falecido",
            G: "Sem exercício na UF",
            I: "Interdição cautelar - total",
            J: "Suspenso por ordem judicial - parcial",
            L: "Cancelado",
            M: "Suspensão total temporária",
            N: "Interdição cautelar - parcial",
            O: "Suspenso por ordem judicial - total",
            P: "Aposentado",
            R: "Suspensão temporária",
            S: "Suspenso - total",
            T: "Transferido",
            X: "Suspenso - parcial",
        };
        return situacoes[situacao] || situacao;
    }
}
